import ResearchIndex from '@rebuild/materials/shared/investment_activity/ResearchIndex.vue';

export const componentMap = {
	full: ResearchIndex
};
